module.exports = __webpack_public_path__ + "media/login-background.7802d39f.mp4";